import { UrlInputPage } from "apps/propertySelection/urlInput/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(UrlInputPage, "AutomaticInputPage");
